import ko from "knockout";
import $ from "jquery";
import { registerKnockoutBinding } from "flow/knockout/register";

registerKnockoutBinding("autoScrollToSelectedOnPulse", {
    update(element, valueAccessor) {
        ko.utils.unwrapObservable(valueAccessor()); // Register dependency

        const $tbody = $(element);
        if (!$tbody.is("tbody")) {
            throw new Error("autoScrollToSelectedOnPulse only works on tbody!");
        }

        const selector = "tr.lc-read-only-table__row--selected";

        const trs = $tbody.find(selector);

        if (trs.length === 1) {
            const tr = trs.first();

            window.requestAnimationFrame(() => {
                tr[0].scrollIntoView();
            });
        }
    }
});
